import type { AnnouncementBarSettings } from '../../types';
import { StopDisplayTriggerTypes } from '../bar-state-provider';

export const isStopDisplayAvailable = (
  stopDisplayValue: StopDisplayTriggerTypes | null | undefined,
  settings: AnnouncementBarSettings
) => {
  const {
    stopDisplayClickedBar,
    stopDisplayClickedActionElement,
    stopDisplayClosedBar,
    stopDisplayReachedViewLimit
  } = settings;

  switch (stopDisplayValue) {
    case StopDisplayTriggerTypes.CLICKEDBAR:
      if (stopDisplayClickedBar) {
        return stopDisplayValue;
      }
      break;
    case StopDisplayTriggerTypes.ACTIONELEMENT:
      if (stopDisplayClickedActionElement) {
        return stopDisplayValue;
      }
      break;
    case StopDisplayTriggerTypes.CLOSEDBAR:
      if (stopDisplayClosedBar) {
        return stopDisplayValue;
      }
      break;
    case StopDisplayTriggerTypes.VIEWLIMIT:
      if (stopDisplayReachedViewLimit) {
        return stopDisplayValue;
      }
      break;
  }
  return null;
};
